import { useState } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export const SearchBar = ({ className = "" }: { className?: string }) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const { t } = useTranslation();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/merchants?q=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={className}>
      <div className="relative">
        <input
          type="search"
          value={query}
          onChange={e => setQuery(e.target.value)}
          placeholder={t("SearchBar.placeholder")}
          className="w-full rounded-pill border border-border-shell bg-surface-blank px-4 py-3 pl-10 font-body text-text-full placeholder-text-light focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/20"
        />
        <svg
          className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-text-light"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>
    </form>
  );
};
